// App.js
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import LoginRegisterForm from "./components/LoginRegisterContainer/LoginRegisterContainer";

import CrewContainer from "./components/CrewDashboard/CrewContainer";
import DriverDetail from "./components/DriverDetails/DriverDetail";
import DriverNew from "./components/DriverDetails/DriverNew";
import DriverCredentials from "./components/DriverDetails/DriverCredentials";
import VehicleAssignment from "./components/DriverDetails/VehicleAssignment";
import AirlineAdd from "./components/DriverDetails/AirlineAdd";
import ImportData from "./components/DriverDetails/ImportData";
import Reports from "./components/Reports";
import FlightStatus from "./components/DriverDetails/FlightStatus";
import AddNote from "./components/DriverDetails/AddNote";
import ScheduleChange from "./components/DriverDetails/ScheduleChange";
import Chart from "./components/Charts/Chart";
import SuperAdminContainer from "./components/CrewDashboard/SuperAdminContainer";
import ManagerDetail from "./components/ManagerDetails/ManagerDetail";
import ManagerNew from "./components/ManagerDetails/ManagerNew";
import ManagerEdit from "./components/ManagerDetails/ManagerEdit";
import ManagerVehicles from "./components/ManagerDetails/ManagerVehicles";
import ManagerDrivers from "./components/ManagerDetails/ManagerDrivers";
import WorkRoleDetails from "./components/ManagerDetails/WorkRoleDetails";
import ManagerLoginCredentials from "./components/ManagerDetails/ManagerLoginCredentials";
import SuperAdminDetails from "./components/SuperAdmin/SuperAdminDetails";
import QRCodes from "./components/SuperAdmin/QRCodes";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DriverInteraction from "./components/DriverDetails/DriverInteraction";
import TripAdd from "./components/Trip/TripAdd";

function App() {
  const [isUserAuthenticated, setUserAuthorization] = useState(false);
  const isUserAuthenticatedRedux = useSelector(
    (state) => state.auth.isAuthenticated
  );
  const user = useSelector((state) => state.auth.user);
  const userRole = sessionStorage.getItem("UserRole");

  const [isAdmin, setAdmin] = useState(
    sessionStorage.getItem("UserRole") === "1" || false
  );
  const sessionAuth = sessionStorage.getItem("isUserAuthenticated") === "true";
  const isAuthenticated = isUserAuthenticatedRedux || sessionAuth;
  const [customerId, setCustomerId] = useState(
    sessionStorage.getItem("customerId") || undefined
  );
  const setUserAuthenticatedStatus = (isAdmin, customerId) => {
    setUserAuthorization(true);
    setAdmin(isAdmin);
    setCustomerId(customerId);
  };

  useEffect(() => {
    const authStatus = sessionStorage.getItem("isUserAuthenticated") === "true";
    setUserAuthorization(authStatus);
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    setUserAuthorization(false);
    setAdmin(false);
    setCustomerId(undefined);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? (
              userRole === "1" ? (
                <Navigate to="/super-admin" replace />
              ) : (
                <Navigate to="/manager" replace />
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/login"
          element={
            <LoginRegisterForm
              setUserAuthenticatedStatus={setUserAuthenticatedStatus}
            />
          }
        />
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to={isAdmin ? "/super-admin" : "/manager"} />
            ) : (
              <LoginRegisterForm
                setUserAuthenticatedStatus={setUserAuthenticatedStatus}
              />
            )
          }
        />

        {isAuthenticated ? (
          <>
            <Route path="/manager" element={<CrewContainer />} />
            <Route path="/super-admin" element={<SuperAdminContainer />} />
            <Route path="/driver-detail" element={<DriverDetail />} />
            <Route path="/driver-new" element={<DriverNew />} />
            <Route path="/driver-info/:id" element={<DriverNew />} />
            <Route path="/driver-credentials" element={<DriverCredentials />} />
            <Route path="/vehicle-assignment" element={<VehicleAssignment />} />
            <Route path="/airline-add" element={<AirlineAdd />} />
            <Route path="/trip-add" element={<TripAdd />} />
            <Route path="/trip-info/:id" element={<TripAdd />} />
            <Route path="/driver-interaction" element={<DriverInteraction />} />
            <Route path="/import-data" element={<ImportData />} />
            <Route path="/import-xls" element={<ImportData />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/flight-status" element={<FlightStatus />} />
            <Route path="/add-note" element={<AddNote />} />
            <Route path="/schedule-change" element={<ScheduleChange />} />
            <Route path="/charts" element={<Chart />} />
            <Route path="/manager-detail" element={<ManagerDetail />} />
            <Route path="/manager-new" element={<ManagerNew />} />
            <Route path="/manager-info/:id" element={<ManagerNew />} />
            <Route path="/manager-edit" element={<ManagerEdit />} />
            <Route path="/manager-vehicles" element={<ManagerVehicles />} />
            <Route path="/manager-drivers" element={<ManagerDrivers />} />
            <Route
              path="/manager-work-role-details"
              element={<WorkRoleDetails />}
            />
            {/* <Route path="/tracking" element={<LeafletMultiDriverTracking />} /> */}

            <Route
              path="/manager-login-credentials"
              element={<ManagerLoginCredentials />}
            />
            <Route path="/safe-super-admin" element={<SuperAdminDetails />} />
            <Route path="/qr-codes" element={<QRCodes />} />
          </>
        ) : (
          <Route path="*" element={<LoginRegisterForm />} />
        )}
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </BrowserRouter>
  );
}

export default App;
